import { makeStyles } from '@material-ui/core'

export const componentePaginacaoStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5)
  }
}))
